export const fiMenus = (logoUrl) => ({
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/fi-fi/',
            url: logoUrl,
            alt: 'Raisin',
        },
    ],
    navItems: [
        {
            id: '7c70fbdd-4e00-5gf2-8b47-87251d3456c5',
            title: 'Säästäminen',
            href: '',
            subMenus: {
                main: [
                    {
                        id: '7c2b631d-9243-4b6a-a2f0-6d781ef3b62d',
                        type: 'advanced',
                        title: 'Määräaikaistalletukset',
                        href: '/fi-fi/maaraaikaistalletukset/',
                        icon: 'fixedDepositIcon',
                        iconColor: '#61AFD2',
                    },
                    {
                        id: '3a9f7b1e-87d0-42e1-b483-51d69ac9c214',
                        type: 'advanced',
                        title: 'Säästötilit',
                        href: '/fi-fi/saastotilit/',
                        icon: 'overnightMoneyIcon',
                        iconColor: '#9CD3E4',
                    },
                ],
            },
        },
        {
            id: '7d81gcdc-4e11-4fe1-8b47-87252d3534c6',
            title: 'Mikä on Raisin',
            href: '',
            subMenus: {
                main: [
                    {
                        id: '9d42c71e-7190-4618-b581-38951fbcf547',
                        type: 'advanced',
                        title: 'Tietoa meistä',
                        href: '/fi-fi/tietoa-raisinista/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt7306ae38b600c7e6/Over_ons.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '76d1f169-c6a1-495e-a495-5fcc74f131ca',
                        type: 'advanced',
                        title: 'Näin Raisin toimii',
                        href: '/fi-fi/nain-raisin-toimii/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt8a5863614d18d6bc/Zo_werkt_het.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '7c436554-958b-4bbd-91b7-fa38a9c0dada',
                        type: 'advanced',
                        title: 'Raisin Bank',
                        href: '/fi-fi/raisin-bank/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt3fda0eed0225803a/Raisin_Bank.svg',
                        iconColor: '#0E6CC5',
                    },
                ],
            },
        },
        {
            id: '7d81gcdc-4e11-4fe2-9c58-878a2q7534c6',
            title: 'Yleistä tietoa',
            href: '',
            subMenus: {
                main: [
                    {
                        id: '9d4v781e-7180-4618-b581-38951a8b5f547',
                        type: 'advanced',
                        title: 'Kumppanipankit',
                        href: '/fi-fi/pankki/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb30f24c72431a3ba/Partnerbanken.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '9d4g882x-b191-46s8-b581-42551an8uf824',
                        type: 'advanced',
                        title: 'Talletussuoja',
                        href: '/fi-fi/talletussuoja/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt8e96e15c429c928b/Einlagensicherung.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '9d4g882x-b191-47s8-b581-426561an7uf824',
                        type: 'advanced',
                        title: 'Verotus',
                        href: '/fi-fi/verotus/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt30ff10945458f646/Belasting.svg',
                        iconColor: '#0E6CC5',
                    },
                ],
            },
        },
        {
            id: '7d61gcdc-4e33-4fe2-9c58-878a2r7534c6',
            title: 'Asiakastuki',
            href: '',
            subMenus: {
                main: [
                    {
                        id: '9d7v781e-728o-46i8-bs81-38951a1b2547',
                        type: 'text',
                        title: 'Kuinka avata Raisin-tili',
                        href: '/fi-fi/tilin-avaaminen/',
                    },
                    {
                        id: '9d6h992y-2i91-56s8-b591-42721a7uf824',
                        type: 'text',
                        title: 'Usein kysytyt kysymykset',
                        href: 'https://asiakastuki.raisin.com/hc/fi-fi',
                    },
                    {
                        id: '9d6g8810z-b100-4s78-b581-42551anvuf824',
                        type: 'text',
                        title: 'Ota yhteyttä',
                        href: '/fi-fi/ota-yhteytta/',
                    },
                ],
            },
        },
    ],
    actionItems: [
        {
            id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
            title: 'Oma tili',
            href: '/fi-fi/login/',
            type: 'login',
        },
        {
            id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
            title: 'Rekisteröidy',
            href: '/fi-fi/register/',
            type: 'registration',
        },
    ],
});
//# sourceMappingURL=fiMenus.js.map